module.exports = __webpack_public_path__ + "img/zuzhitop.e5b2bda7.png";